import {
    AnimalsTaskType,
    InspectionGroup,
    MaintenanceTaskType,
    RefuellingTaskType,
    TaskCategory,
    TaskProcessType,
    TaskStatus,
    TerminalTaskType,
} from 'aos-services/src/services/tasks/types'
import { IconVariant } from 'aos-ui/src/components/svg/Icon'
import { SvgIcon } from 'aos-ui/src/components/svg/SvgIcon'
import {
    AnimalsEyeReviewIcon,
    AnimalsGraveIcon,
    AnimalsNotAllowedIcon,
    EquipmentMaintenanceIcon,
    FlagDayIcon,
    FlightsCheckIcon,
    HeatingWiresIcon,
    IconSource,
    LoadReceptionIcon,
    LVPLowVisibilityIcon,
    RefuellingIcon,
    RegularInspectionIcon,
    SnowflakeIcon,
    SupervisionIcon,
    TakingSamplesIcon,
    TaskAnimalObservationIcon,
    TaskAnimalsIcon,
    TaskHbaIcon,
    TaskInspectionAreaInspectionIcon,
    TaskInspectionContractorIcon,
    TaskInspectionFireTruckIcon,
    TaskInspectionFodIcon,
    TaskInspectionOtherActorsIcon,
    TaskInspectionOtherAreasIcon,
    TaskInspectionOtherIcon,
    TaskInspectionRopeIcon,
    TaskInspectionRunwayIcon,
    TaskInspectionTaxiwayIcon,
    TaskInspectionTerminalIcon,
    TaskMaintenanceBrushesIcon,
    TaskMaintenanceGeneralIcon,
    TaskMaintenanceIcon,
    TaskMaintenanceSummerIcon,
    TaskOtherIcon,
    TaskProcessAutomatedVehicleIcon,
    TaskProcessDailyMaintenanceIcon,
    TaskProcessDailyTerminalIcon,
    TaskProcessSeasonalIcon,
    TaskRescueServiceIcon,
    TaskSafetyInspectionIcon,
    TeminalSecurityIcon,
    TerminalIcon,
    TerminalPassengerSelfServiceIcon,
} from 'aos-ui-universal'

export const animalTaskTypeIcons: Record<AnimalsTaskType, IconSource> = {
    [AnimalsTaskType.Observation]: TaskAnimalObservationIcon,
    [AnimalsTaskType.Banishment]: AnimalsNotAllowedIcon,
    [AnimalsTaskType.Confirmation]: AnimalsEyeReviewIcon,
    [AnimalsTaskType.Kill]: AnimalsGraveIcon,
}

export const terminalTaskTypeIcon: Record<TerminalTaskType, IconSource> = {
    [TerminalTaskType.FlagDay]: FlagDayIcon,
    [TerminalTaskType.CUSSParkingMeters]: TerminalPassengerSelfServiceIcon,
    [TerminalTaskType.FlightChecks]: FlightsCheckIcon,
    [TerminalTaskType.HeatingWires]: HeatingWiresIcon,
    [TerminalTaskType.Security]: TeminalSecurityIcon,
    [TerminalTaskType.Other]: TaskOtherIcon,
}

export const inspectionGroupIcons: Record<InspectionGroup, IconSource> = {
    [InspectionGroup.Terminal]: TaskInspectionTerminalIcon,
    [InspectionGroup.Runway]: TaskInspectionRunwayIcon,
    [InspectionGroup.Taxiway]: TaskInspectionTaxiwayIcon,
    [InspectionGroup.FireTrucks]: TaskInspectionFireTruckIcon,
    [InspectionGroup.Rope]: TaskInspectionRopeIcon,
    [InspectionGroup.Contractor]: TaskInspectionContractorIcon,
    [InspectionGroup.Other]: TaskInspectionOtherIcon,
    [InspectionGroup.Fod]: TaskInspectionFodIcon,
    [InspectionGroup.OtherActors]: TaskInspectionOtherActorsIcon,
    [InspectionGroup.OtherAreas]: TaskInspectionOtherAreasIcon,
    [InspectionGroup.AreaInspection]: TaskInspectionAreaInspectionIcon,
}

export const maintenanceTaskTypeIcons: Record<MaintenanceTaskType, IconSource> = {
    [MaintenanceTaskType.General]: TaskMaintenanceGeneralIcon,
    [MaintenanceTaskType.Winter]: SnowflakeIcon,
    [MaintenanceTaskType.Summer]: TaskMaintenanceSummerIcon,
    [MaintenanceTaskType.Brushes]: TaskMaintenanceBrushesIcon,
}

export const refuellingTaskTypeIcon: Record<RefuellingTaskType, IconSource> = {
    [RefuellingTaskType.REFUELLING]: RefuellingIcon,
    [RefuellingTaskType.EQUIPMENT_MAINTENANCE]: EquipmentMaintenanceIcon,
    [RefuellingTaskType.OTHER]: TaskOtherIcon,
    [RefuellingTaskType.SUPERVISION_ESCORT]: SupervisionIcon,
    [RefuellingTaskType.LOAD_RECEPTION]: LoadReceptionIcon,
    [RefuellingTaskType.REGULAR_INSPECTION]: RegularInspectionIcon,
    [RefuellingTaskType.TAKING_SAMPLES]: TakingSamplesIcon,
}

export const taskCategoryIcon: Record<TaskCategory, IconSource> = {
    [TaskCategory.Animals]: TaskAnimalsIcon,
    [TaskCategory.Maintenance]: TaskMaintenanceIcon,
    [TaskCategory.DeIcing]: SnowflakeIcon,
    [TaskCategory.RescueService]: TaskRescueServiceIcon,
    [TaskCategory.Inspection]: TaskSafetyInspectionIcon,
    [TaskCategory.LVP]: LVPLowVisibilityIcon,
    [TaskCategory.HBA]: TaskHbaIcon,
    [TaskCategory.Refuelling]: RefuellingIcon,
    [TaskCategory.Terminal]: TerminalIcon,
}

export const taskProcessTypeIcon: Record<TaskProcessType, IconSource> = {
    [TaskProcessType.Daily]: TaskProcessDailyMaintenanceIcon,
    [TaskProcessType.Seasonal]: TaskProcessSeasonalIcon,
    [TaskProcessType.DailyTerminal]: TaskProcessDailyTerminalIcon,
    [TaskProcessType.AutomatedVehicleTask]: TaskProcessAutomatedVehicleIcon,
}

export const taskIcon: Record<TaskCategory, Svg> = {
    [TaskCategory.Animals]: SvgIcon.TaskAnimals,
    [TaskCategory.Maintenance]: SvgIcon.TaskMaintenance,
    [TaskCategory.DeIcing]: SvgIcon.TaskDeicing,
    [TaskCategory.RescueService]: SvgIcon.TaskRescueService,
    [TaskCategory.Inspection]: SvgIcon.TaskSafetyInspection,
    [TaskCategory.LVP]: SvgIcon.TaskLvp,
    [TaskCategory.HBA]: SvgIcon.TaskHba,
    [TaskCategory.Refuelling]: SvgIcon.TaskRefuelling,
    [TaskCategory.Terminal]: SvgIcon.Terminal,
}

export const taskIconVariant: Record<TaskStatus, IconVariant> = {
    [TaskStatus.Todo]: IconVariant.White,
    [TaskStatus.InProgress]: IconVariant.White,
    [TaskStatus.OnHold]: IconVariant.White,
    [TaskStatus.Done]: IconVariant.MenuButton,
    [TaskStatus.Cancelled]: IconVariant.MenuButton,
}
